module.exports = __webpack_public_path__ + "img/integralPlay_bg.b0a56ec7.jpg";